export default __webpack_public_path__ + "static/IP_Vision_Pro_07-b3c979d728f84555802fd4b50ff14689.webp";